import * as actionTypes from '../actions/actionTypes';

export const fetchSellersList = (data) => {
    return {
        type: actionTypes.FETCH_SELLERS_LIST,
        sellers: data
    }
}
export const createSeller = (data) => {
    return {
        type: actionTypes.CREATE_SELLER,
        seller: data
    }
}
export const deleteSeller = (id) => {
    return {
        type: actionTypes.DELETE_SELLER,
        id
    }
}
export const updateSeller = (data) => {
    return {
        type: actionTypes.UPDATE_SELLER,
        data
    }
}
export const clearSeller = () => {
    return {
        type: actionTypes.CLEAR_SELLER
    }
}